// src/components/LevelRewardModal.jsx
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./LevelRewardModal.css";
import socket from '../socket';



// const API_ORIGIN = process.env.REACT_APP_API_URL;   // напр. http://147.93.123.26:5000
// const API_BASE   = `${API_ORIGIN}/api`;
const API_ORIGIN = (process.env.REACT_APP_API_URL || '').replace(/\/+$/,'');
const API_BASE   = `${API_ORIGIN.replace(/\/api$/,'')}/api`;


const CARD_COUNT = 10;

/* тайминги и поведение «домино»  */
const PREVIEW_MS = 7000;
const COVER_STAGGER_MS = 70;
const DOMINO_TOTAL_MS = 2200;
const DOMINO_TICK_MS  = 260;
const DOMINO_ROT_MAX  = 25;
const DOMINO_STEP_PX  = 80;
const GRID_ANIM_MS    = 520;

/** Колода по умолчанию — ТОЛЬКО допустимые типы твоей утилиты */
const FALLBACK_DECK = [
  { type: "money",  amount: 1 },
  { type: "ticket", count: 1 },
  { type: "coins",  amount: 50 },
  { type: "money",  amount: 3 },
  { type: "coins",  amount: 75 },
  { type: "ticket", count: 1 },
  { type: "money",  amount: 50 },
  { type: "coins",  amount: 100 },
  { type: "ticket", count: 1 },
  { type: "money",  amount: 10 },
];






/** Если /rewards/start отдаст старые типы — приводим к нужным */
function normalizeItem(it) {
  if (!it) return it;
  const t = String(it.type || "").toLowerCase();
  if (t === "money" || t === "cash")  return { type: "money",  amount: Number(it.amount ?? it.value ?? 0) };
  if (t === "coins" || t === "xp")    return { type: "coins",  amount: Number(it.amount ?? it.value ?? 0) };
  if (t === "ticket") {
    const face  = Number(it.face ?? it.value ?? it.amount ?? 1);
    const count = Number(it.count ?? 1);
    return { type: "ticket", face, count };
  }
  return null;
}


function ids(n){ return Array.from({length:n},(_,i)=>i); }
function shuffle(a){ const r=a.slice(); for(let i=r.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[r[i],r[j]]=[r[j],r[i]]} return r; }


const SKIN_LABEL_KEYS = {
  wood_dice: 'profile.rewardModal.skins.woodDice',
  bronze: 'profile.rewardModal.skins.bronze',
  silver: 'profile.rewardModal.skins.silver',
  gold: 'profile.rewardModal.skins.gold',
  platinum: 'profile.rewardModal.skins.platinum',
  diamond: 'profile.rewardModal.skins.diamond',
  basic_board: 'profile.rewardModal.skins.basicBoard',
  wood_board: 'profile.rewardModal.skins.woodBoard',
  gold_board: 'profile.rewardModal.skins.goldBoard',
  marble_board: 'profile.rewardModal.skins.marbleBoard',
  vip_gold: 'profile.rewardModal.skins.vipGold',
  vip_marble: 'profile.rewardModal.skins.vipMarble',
  vip_black: 'profile.rewardModal.skins.vipBlack',
};



const labelOf = (item, translate) => {
  if (!item) return '🎁';

  switch (item.type) {
    case 'money':
      return `$${item.amount ?? 0}`;

    case 'coins':
      return `XP +${item.amount ?? 0}`;

    case 'ticket': {
      const face = item.face ?? 1;
      const count = item.count ?? 1;

      return translate('profile.rewardModal.ticket', {
        face,
        count,
      });
    }

    case 'skin': {
      const key =
        item.skin_type ||
        item.skinId ||
        item.skin;

      const labelKey = SKIN_LABEL_KEYS[key];

      return labelKey
        ? translate(labelKey)
        : translate('profile.rewardModal.unknownSkin', {
            key:
              key ||
              translate('profile.rewardModal.unknown'),
          });
    }

    default:
      return '…';
  }
}; 


// const labelOf = (item) => {
//   if (!item) return "Открываем…";
//   switch (item.type) {
//     case "money":  return `$${item.amount ?? 0}`;
//     case "coins":  return `XP +${item.amount ?? 0}`;
//     case "ticket": {
//       const face = item.face ?? 1, cnt = item.count ?? 1;
//       return `Билет $${face}${cnt > 1 ? ` ×${cnt}` : ""}`;
//     }
//     default: return "…";
//   }
// };

// const labelOf = (item) => {
//   if (!item) return '…';
//   switch (item.type) {
//     case 'money':  return `$${item.amount ?? 0}`;
//     case 'coins':  return `XP +${item.amount ?? 0}`;
//     case 'ticket': {
//       const face = item.face ?? item.value ?? 1;
//       const cnt  = item.count ?? 1;
//       return `Билет $${face}${cnt > 1 ? ` ×${cnt}` : ''}`;
//     }
//     default:       return '…';
//   }
// };

export default function LevelRewardModal({
  username,
  showRewardModal,
  setShowRewardModal,
  setShowGiftIcon,
}) {
  const { t: translate } = useTranslation();
  const [stage, setStage] = useState("idle"); // loading|preview|covering|domino|picking|done
  const [deck, setDeck] = useState(FALLBACK_DECK);
  const [orderMap, setOrderMap] = useState(ids(CARD_COUNT)); // для flex-order
  const [flippedId, setFlippedId] = useState(null);
  const [reward, setReward] = useState(null);

  const gridRef  = useRef(null);
  const cardRefs = useRef(Array(CARD_COUNT).fill(null));
  const dominoTimerRef = useRef(null);
  const tickRef  = useRef(null);
  const [gridHeight, setGridHeight] = useState(0);

  const canPick = stage === "picking" && flippedId == null;

  useEffect(() => {
    if (!showRewardModal) return;
    let timeouts = [];

    (async () => {
      setStage("loading");
      setFlippedId(null);
      setReward(null);
      setOrderMap(ids(CARD_COUNT));

      // зафиксируем высоту сетки (для абсолютного позиционирования в домино)
      requestAnimationFrame(() => {
        const r = gridRef.current?.getBoundingClientRect();
        if (r) setGridHeight(r.height);
      });

      // 1) пробуем получить колоду предпросмотра с сервера
      // try {
      //   const res = await fetch(`${API_BASE}/auth/rewards/start?username=${encodeURIComponent(username || "")}`);
      //   if (res.ok) {
      //     const data = await res.json();
      //     const rawDeck = Array.isArray(data.deck) ? data.deck : FALLBACK_DECK;
      //     const normalized = rawDeck.slice(0, CARD_COUNT).map(normalizeItem);
      //     // если вдруг элементов меньше — добьём до 10
      //     while (normalized.length < CARD_COUNT) normalized.push(...FALLBACK_DECK.slice(0, CARD_COUNT - normalized.length));
      //     setDeck(normalized);
      //   } else {
      //     setDeck(FALLBACK_DECK);
      //   }
      // } catch {
      //   setDeck(FALLBACK_DECK);
      // }
      // 1) пробуем получить колоду предпросмотра с сервера
try {
  const token = localStorage.getItem('token') || '';
  const res = await fetch(
    `${API_BASE}/auth/rewards/start?username=${encodeURIComponent(username || "")}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (res.ok) {
    const data = await res.json();
    const rawDeck = Array.isArray(data.deck) ? data.deck : FALLBACK_DECK;
    const normalized = rawDeck.slice(0, CARD_COUNT).map(normalizeItem);
    while (normalized.length < CARD_COUNT) {
      normalized.push(...FALLBACK_DECK.slice(0, CARD_COUNT - normalized.length));
    }
    setDeck(normalized);
  } else {
    setDeck(FALLBACK_DECK);
  }
} catch {
  setDeck(FALLBACK_DECK);
}


      // 2) показываем все открытыми
      setStage("preview");

      // 3) закрываем ступенькой (клики заблочены классами)
      timeouts.push(setTimeout(() => setStage("covering"), PREVIEW_MS));

      // 4) стартуем «домино»
      const afterCover = PREVIEW_MS + COVER_STAGGER_MS * CARD_COUNT + 150;
      timeouts.push(setTimeout(startDominoShuffle, afterCover));
    })();

    return () => { timeouts.forEach(clearTimeout); stopDominoShuffle(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showRewardModal, username]);

  function startDominoShuffle() {
    setStage("domino");

    const grid = gridRef.current;
    const cont = grid.getBoundingClientRect();

    // переводим карты в абсолют
    cardRefs.current.forEach((el) => {
      const r = el.getBoundingClientRect();
      el.style.position   = "absolute";
      el.style.left       = `${r.left - cont.left}px`;
      el.style.top        = `${r.top  - cont.top }px`;
      el.style.transform  = "translate(0,0) rotate(0deg)";
      el.style.transition = `transform ${DOMINO_TICK_MS}ms ease`;
      el.style.zIndex     = "1";
    });

    const ticks = Math.max(2, Math.floor(DOMINO_TOTAL_MS / DOMINO_TICK_MS));
    let i = 0;

    tickRef.current = setInterval(() => {
      i++;
      cardRefs.current.forEach((el, idx) => {
        const baseLeft = parseFloat(el.style.left) || 0;
        const baseTop  = parseFloat(el.style.top)  || 0;

        const nx = clamp(baseLeft + randBetween(-DOMINO_STEP_PX, DOMINO_STEP_PX), 0, cont.width  - el.offsetWidth  );
        const ny = clamp(baseTop  + randBetween(-DOMINO_STEP_PX, DOMINO_STEP_PX), 0, cont.height - el.offsetHeight );

        const dx = nx - baseLeft;
        const dy = ny - baseTop;
        const ang = randBetween(-DOMINO_ROT_MAX, DOMINO_ROT_MAX);

        el.style.transform = `translate(${dx}px, ${dy}px) rotate(${ang}deg)`;
        el.style.zIndex = String(10 + (i%3) + (idx%5));
      });

      if (i >= ticks) finishDominoShuffle();
    }, DOMINO_TICK_MS);

    dominoTimerRef.current = setTimeout(finishDominoShuffle, DOMINO_TOTAL_MS + 30);
  }

  function stopDominoShuffle() {
    if (tickRef.current)             { clearInterval(tickRef.current);         tickRef.current = null; }
    if (dominoTimerRef.current)      { clearTimeout(dominoTimerRef.current);   dominoTimerRef.current = null; }
  }

  function finishDominoShuffle() {
    stopDominoShuffle();

    const newOrder = shuffle(ids(CARD_COUNT));
    const first = cardRefs.current.map(el => el.getBoundingClientRect());

    setOrderMap(newOrder);

    requestAnimationFrame(() => {
      cardRefs.current.forEach((el) => {
        el.style.position = "";
        el.style.left = "";
        el.style.top  = "";
      });

      const last = cardRefs.current.map(el => el.getBoundingClientRect());

      cardRefs.current.forEach((el, k) => {
        const dx = first[k].left - last[k].left;
        const dy = first[k].top  - last[k].top;
        el.style.transform = `translate(${dx}px, ${dy}px)`;
        el.style.transition = "transform 0s";
        requestAnimationFrame(() => {
          el.style.transition = `transform ${GRID_ANIM_MS}ms ease`;
          el.style.transform = "translate(0,0)";
        });
      });

      setTimeout(() => {
        cardRefs.current.forEach((el) => { el.style.transform = ""; el.style.transition = ""; el.style.zIndex = ""; });
        setStage("picking");
      }, GRID_ANIM_MS + 20);
    });
  }

  async function handlePick(id) {
    if (!canPick) return;
    setFlippedId(id);
    setReward(null);  
    setStage("done");
   

    try {
      // ⚠️ Твоя утилита принимает только { username, index }
//      const res = await fetch(`${API_BASE}/auth/rewards/claim-card`, {
//   method: "POST",
//   headers: { "Content-Type": "application/json" },
//   body: JSON.stringify({ username, index: id }),
// });

const token = localStorage.getItem('token') || '';
const res = await fetch(`${API_BASE}/auth/rewards/claim-card`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  },
  body: JSON.stringify({ username, index: id }) // если сервер ждёт 1..10 — поставь id+1
});


      const data = await res.json();
      if (data?.reward) setReward(data.reward);
      setShowGiftIcon(false);

      // ⬇️ МГНОВЕННОЕ ОБНОВЛЕНИЕ СОСТОЯНИЯ БЕЗ ПЕРЕЗАГРУЗКИ
try {
  const r = data?.reward || null;

  // 1) Деньги: локально плюсуем и просим сервер прислать канонический баланс
  if (r && r.type === 'money' && Number(r.amount) > 0) {
    // delta-режим (App уже слушает 'balance-updated')
    window.dispatchEvent(new CustomEvent('balance-updated', {
      detail: { add: Number(r.amount), source: 'reward' }
    }));

    // попросим сервер отправить свежий баланс через сокет
    if (username) {
      socket.emit('getUserBalance', { username });
    }
  }

  // 2) XP/уровень: даём сигнал на рефреш (Header слушает 'level-refresh' и refetch-ит уровень)
  if (r && r.type === 'coins') {
    window.dispatchEvent(new CustomEvent('level-refresh'));
  }

  // 3) Билеты/скины: рефетчим /user/assets и рассылаем в окно событие, которое App ловит
  if (r && (r.type === 'ticket' || r.type === 'skin')) {
    const token = localStorage.getItem('token');
    if (token) {
      const resAssets = await fetch(`${API_BASE}/user/assets`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (resAssets.ok) {
        const fresh = await resAssets.json();
        window.dispatchEvent(new CustomEvent('assets-updated', { detail: fresh }));
      }
    }
  }

  // 4) (опционально) всегда дернуть level-refresh, если сервер по coins мог ещё и level апнуть
  if (r && r.type !== 'coins') {
    // на всякий случай, чтобы nextLevelXP/levelPoints точно подтянулись
    window.dispatchEvent(new CustomEvent('level-refresh'));
  }
} catch (e) {
  console.error('[RewardModal] post-claim refresh failed:', e);
}


    } catch (e) {
      console.error(e);
    }
  }

  if (!showRewardModal) return null;

  return (
    <div className="reward-modal-overlay">
     <div className={`reward-modal ${
          stage === "preview"   ? "is-preview"   : ""
        } ${stage === "covering" ? "is-covering" : ""} ${
          stage === "picking"   ? "is-picking"   : ""
        }`}>

        <h2 className="reward-title">
          {stage === 'preview'
            ? translate('profile.rewardModal.preview')
            : stage === 'domino'
              ? translate('profile.rewardModal.shuffling')
              : stage === 'picking'
                ? translate('profile.rewardModal.pick')
                : translate('profile.rewardModal.preparing')}
        </h2>

        <div
          ref={gridRef}
          className={`card-grid ${stage === "domino" ? "is-domino" : ""}`}
          style={stage === "domino" ? { height: gridHeight } : undefined}
        >
          {ids(CARD_COUNT).map((id) => {
            const isOpen =
              stage === "preview" || (flippedId === id && (stage === "done" || stage === "picking"));
            return (
              <button
                key={id}
                ref={(el) => (cardRefs.current[id] = el)}
                type="button"
                className={`reward-card ${isOpen ? "is-flipped" : ""} ${!canPick ? "is-disabled" : ""}`}
                onClick={() => handlePick(id)}
                style={{ order: orderMap[id], "--i": id }}
                aria-label={translate('profile.rewardModal.cardAria', { number: id + 1 })}
              >
                <div className="reward-card__inner">
                  <div className="reward-card__face reward-card__face--back" />
                  <div className="reward-card__face reward-card__face--front">
                    <div className="reward-card__prize">
                      {isOpen ? labelOf(flippedId === id ? reward : deck[id], translate) : '🎁'}
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>

       <div className="reward-actions">
  {flippedId !== null && (
    <button
      className="reward-close"
      onClick={() => setShowRewardModal(false)}
    >
      {translate('profile.common.close')}
    </button>
  )}
</div>

      </div>
    </div>
  );
}

/* helpers */
function randBetween(min, max){ return Math.random()*(max-min)+min; }
function clamp(v, a, b){ return Math.max(a, Math.min(b, v)); }



